import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=55ebf791&"
import script from "./Book.vue?vue&type=script&lang=js&"
export * from "./Book.vue?vue&type=script&lang=js&"
import style0 from "./Book.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55ebf791')) {
      api.createRecord('55ebf791', component.options)
    } else {
      api.reload('55ebf791', component.options)
    }
    module.hot.accept("./Book.vue?vue&type=template&id=55ebf791&", function () {
      api.rerender('55ebf791', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/運勢書2024/Book.vue"
export default component.exports